<template>
  <div class="Home">
    <home-banner
      :style="{
        backgroundImage: `url(${bannerBg})`,
        backgroundSize: '100% 100%',
      }"
    ></home-banner>
    <home-procurement />
    <home-want-buy />
    <home-news />
  </div>
</template>

<script>
import { getStore } from "@/utils/auth";
import HomeBanner from "./home/HomeBanner.vue";
import HomeProcurement from "./home/HomeProcurement.vue";
import HomeWantBuy from "./home/HomeWantBuy.vue";
import HomeNews from "./home/HomeNews.vue";

export default {
  name: "Home",
  components: {
    HomeBanner,
    HomeProcurement,
    HomeWantBuy,
    HomeNews,
  },
  data() {
    return {
      token: getStore("token"),
      bannerBg: require("@/assets/img/bannerBg.png"),
    };
  },
  watch: {},
  created() {
    this.$store.commit("changeshowFooterState", true);
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
@import "~@/static/styles/variables.less";
.Home {
  width: 100%;
  min-height: 100%;
}
</style>
